import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Dialog, DialogContent, DialogActions } from "@mui/material"

import { RootState } from "../../../store/configureStore"
import { setSpotTaken } from "../../../actions/searchActions"

// Modal that appears when a spot is being reserved already.

const SpotAlreadyTaken = () => {
  const dispatch = useDispatch()
  const { isSpotTaken } = useSelector((state: RootState) => state.search)

  const refresh = () => {
    dispatch(setSpotTaken(false))
    // Refresh the page. Should we do this a smarter way?
    window.location.reload()
  }

  const handleDialogClosed = (event: React.SyntheticEvent, reason: string) => {
    if (reason !== "backdropClick") {
      refresh()
    }
  }

  return (
    <Dialog
      open={isSpotTaken}
      data-cy="already-taken-dialog"
      onClose={handleDialogClosed}
      disableEscapeKeyDown
    >
      <DialogContent>
        We apologize but the date and time you chose is currently being booked
        by another student. If they do not complete their booking the spot will
        become available again in the next 10 minutes. Tap OK below to choose a
        different time.
      </DialogContent>
      <DialogActions>
        <Button onClick={refresh}>OK</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SpotAlreadyTaken
